module.exports = __webpack_public_path__ + "media/images/metronic/remove-icon-small-4c864f223811783a88b54a420d9a809c.png";